import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-ink px-5 py-20 text-white sm:px-8" data-id="element-17" data-mp="pm29dppob3dv">
      <div className="mx-auto w-full max-w-6xl" data-id="element-18" data-mp="aua4y8rf39qx">
        <Reveal data-id="element-19" data-mp="fu69c9411370">
          <h2 className="flex flex-wrap items-center justify-center gap-3 text-center font-display text-3xl font-extrabold tracking-tight sm:text-4xl" data-id="element-20" data-mp="ftmwv7x5b70d">
            <GiftIcon className="h-8 w-8 text-gold" aria-hidden="true" data-id="element-21" data-mp="1whqt7xfm854" />
            <span data-id="element-22" data-mp="5wrvmh9hmsie">
              You Also Get <span className="text-cheer" data-id="element-23" data-mp="5tnkezxluwi8">5 Strategic Bonuses</span>
            </span>
          </h2>
          <p className="mt-4 text-center text-sm font-semibold uppercase tracking-widest text-gold" data-id="element-24" data-mp="3o3y4rpxfyy6j">
            Real value: $87 — today: Free
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-25" data-mp="1mart7lkv262h">
          {bonuses.map((bonus, index) => <Reveal key={bonus.tag} delay={index % 3 * 0.05} className="h-full" data-id="element-26" data-mp="1r78qp6dy9ws8" data-mpi={index}>
              <article className="flex h-full flex-col overflow-hidden rounded-card border border-cheer/40 bg-[#121218] transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-27" data-mp="3iclmzqn9ggxa">
                <div className="border-b border-cheer/20 bg-[#17171f]" data-id="element-28" data-mp="3r68ev5ocl017">
                  <img src={bonus.image} alt={bonus.imageAlt} loading="lazy" className="aspect-square w-full object-cover" data-id="element-29" data-mp="3n4wnaulwy4qd" />
                </div>
                <div className="flex flex-1 flex-col p-5" data-id="element-30" data-mp="2uibxvzp002pg">
                  <span className="w-fit rounded-full bg-gold px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-navy" data-id="element-31" data-mp="38hbjszl4m3hx">
                    {bonus.tag}
                  </span>
                  <h3 className="mt-3 font-display text-base font-extrabold leading-snug" data-id="element-32" data-mp="np8d0ml1hllw">
                    {bonus.title}
                  </h3>
                  <p className="mt-auto pt-2 text-sm leading-relaxed text-white/60" data-id="element-33" data-mp="iqom07rl9jmo">
                    {bonus.description}
                  </p>
                </div>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}